import { useState, useEffect } from 'react';
import './Services.css';

function Services() {
  const [trainers, setTrainers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // 模拟获取教练数据，实际项目中可调用 API
    // 这里使用静态数据演示
    setTrainers([
      { id: 1, name: '何教练', specialty: ['增肌', '减脂'] },
      { id: 2, name: '方方梨', specialty: ['塑形', '体能'] },
    ]);
    setLoading(false);
  }, []);

  return (
    <div className="services-page">
      <header className="page-header">
        <h1 className="page-title">服务介绍</h1>
      </header>

      <main className="page-content">
        {/* 关于我们 */}
        <section className="section about-section">
          <h2 className="section-title">关于我们</h2>
          <div className="about-card">
            <img src="/5.jpg" alt="门店图片" className="store-image" />
            <div className="about-content">
              <span className="about-name">趣炼游戏健身</span>
              <span className="about-desc">专业健身指导，科学训练方案，让您享受运动的乐趣</span>
            </div>
          </div>
        </section>

        {/* 服务项目 */}
        <section className="section">
          <h2 className="section-title">服务项目</h2>
          <div className="services-list">
            <div className="service-item">
              <span className="service-num">1</span>
              <div className="service-content">
                <span className="service-title">器械健身</span>
                <span className="service-desc">全套进口器械，设备齐全，环境舒适</span>
              </div>
            </div>
            <div className="service-item">
              <span className="service-num">2</span>
              <div className="service-content">
                <span className="service-title">私教指导</span>
                <span className="service-desc">专业私教一对一指导，制定个性化训练计划</span>
              </div>
            </div>
            <div className="service-item">
              <span className="service-num">3</span>
              <div className="service-content">
                <span className="service-title">拍档服务</span>
                <span className="service-desc">智能设备辅助训练，教练实时指导，随时呼叫</span>
              </div>
            </div>
            <div className="service-item">
              <span className="service-num">4</span>
              <div className="service-content">
                <span className="service-title">淋浴更衣</span>
                <span className="service-desc">独立淋浴间、更衣室，干净卫生</span>
              </div>
            </div>
          </div>
        </section>

        {/* 教练团队 */}
        <section className="section">
          <h2 className="section-title">教练团队</h2>
          {loading ? (
            <div className="loading">加载中...</div>
          ) : trainers.length > 0 ? (
            <div className="trainers-grid">
              {trainers.slice(0, 4).map((trainer) => (
                <div key={trainer.id} className="trainer-card">
                  <div className="trainer-avatar">
                    <span className="trainer-avatar-text">{trainer.name?.charAt(0) || '?'}</span>
                  </div>
                  <span className="trainer-name">{trainer.name}</span>
                  <span className="trainer-specialty">{trainer.specialty?.slice(0, 2).join('、') || '专业教练'}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty">暂无教练信息</div>
          )}
        </section>

        {/* 联系方式 */}
        <section className="section">
          <h2 className="section-title">联系方式</h2>
          <div className="contact-card">
            <div className="contact-item">
              <span className="contact-label">地址</span>
              <span className="contact-value">成都市武侯区来凤四路151号</span>
            </div>
            <div className="contact-item">
              <span className="contact-label">营业时间</span>
              <span className="contact-value">24小时营业</span>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default Services;
